module.exports = __webpack_public_path__ + "img/5.474c3d66.png";